import { render, staticRenderFns } from "./ProjectDetailStatisticBoard.vue?vue&type=template&id=e324b668&"
import script from "./ProjectDetailStatisticBoard.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailStatisticBoard.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailStatisticBoard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports